module.exports = __webpack_public_path__ + "img/tu1.0e4d3f92.jpg";